var map = {
	"./appointments/add": 7040,
	"./appointments/add.js": 7040,
	"./appointments/addPane": 5652,
	"./appointments/addPane.vue": 5652,
	"./appointments/addTab": 5229,
	"./appointments/addTab.vue": 5229,
	"./appointments/edit": 9331,
	"./appointments/edit.js": 9331,
	"./appointments/editPane": 9448,
	"./appointments/editPane.vue": 9448,
	"./appointments/editTab": 8792,
	"./appointments/editTab.vue": 8792,
	"./appointments/pabauPane": 5672,
	"./appointments/pabauPane.vue": 5672,
	"./appointments/pabauTab": 4632,
	"./appointments/pabauTab.vue": 4632,
	"./appointments/syncUser": 8723,
	"./appointments/syncUser.vue": 8723,
	"./callback/add": 4613,
	"./callback/add.js": 4613,
	"./callback/addPane": 2306,
	"./callback/addPane.vue": 2306,
	"./callback/addTab": 2389,
	"./callback/addTab.vue": 2389,
	"./callback/edit": 9776,
	"./callback/edit.js": 9776,
	"./callback/editPane": 4042,
	"./callback/editPane.vue": 4042,
	"./callback/editTab": 8324,
	"./callback/editTab.vue": 8324,
	"./clients/add": 2492,
	"./clients/add.js": 2492,
	"./clients/addPane": 4252,
	"./clients/addPane.vue": 4252,
	"./clients/addTab": 6442,
	"./clients/addTab.vue": 6442,
	"./clients/edit": 1455,
	"./clients/edit.js": 1455,
	"./clients/editPane": 4316,
	"./clients/editPane.vue": 4316,
	"./clients/editTab": 4468,
	"./clients/editTab.vue": 4468,
	"./complaints/add": 1920,
	"./complaints/add.js": 1920,
	"./complaints/addPane": 1866,
	"./complaints/addPane.vue": 1866,
	"./complaints/addTab": 5915,
	"./complaints/addTab.vue": 5915,
	"./complaints/deal": 673,
	"./complaints/deal.vue": 673,
	"./complaints/edit": 4323,
	"./complaints/edit.js": 4323,
	"./complaints/editPane": 7873,
	"./complaints/editPane.vue": 7873,
	"./complaints/editTab": 3092,
	"./complaints/editTab.vue": 3092,
	"./customers/add": 7169,
	"./customers/add.vue": 7169,
	"./customers/addOpp": 4724,
	"./customers/addOpp.vue": 4724,
	"./customers/edit": 3527,
	"./customers/edit.vue": 3527,
	"./deals/add": 4227,
	"./deals/add.vue": 4227,
	"./insights/view": 9523,
	"./insights/view.vue": 9523,
	"./leads/EditAppointment": 9039,
	"./leads/EditAppointment.vue": 9039,
	"./leads/EditCallback": 4122,
	"./leads/EditCallback.vue": 4122,
	"./leads/QuickAddLead": 2425,
	"./leads/QuickAddLead.vue": 2425,
	"./leads/addLead": 1685,
	"./leads/addLead.js": 1685,
	"./leads/addPane": 1328,
	"./leads/addPane.vue": 1328,
	"./leads/addTab": 2908,
	"./leads/addTab.vue": 2908,
	"./leads/editLead": 9128,
	"./leads/editLead.js": 9128,
	"./leads/editPane": 5422,
	"./leads/editPane.vue": 5422,
	"./leads/editTab": 7383,
	"./leads/editTab.vue": 7383,
	"./notifications/add": 5801,
	"./notifications/add.vue": 5801,
	"./notifications/update": 7857,
	"./notifications/update.vue": 7857,
	"./offers/add": 2993,
	"./offers/add.vue": 2993,
	"./offers/update": 4941,
	"./offers/update.vue": 4941,
	"./opportunities/QuickAddLead": 7827,
	"./opportunities/QuickAddLead.vue": 7827,
	"./opportunities/addLead": 211,
	"./opportunities/addLead.js": 211,
	"./opportunities/addPane": 7299,
	"./opportunities/addPane.vue": 7299,
	"./opportunities/addTab": 8296,
	"./opportunities/addTab.vue": 8296,
	"./opportunities/editLead": 2698,
	"./opportunities/editLead.js": 2698,
	"./opportunities/editPane": 5385,
	"./opportunities/editPane.vue": 5385,
	"./opportunities/editTab": 6128,
	"./opportunities/editTab.vue": 6128,
	"./sales/deal": 6513,
	"./sales/deal.vue": 6513,
	"./sales/edit": 1811,
	"./sales/edit.vue": 1811,
	"./sales/payment": 7966,
	"./sales/payment.vue": 7966,
	"./settings/branches/add": 7939,
	"./settings/branches/add.vue": 7939,
	"./settings/branches/edit": 2379,
	"./settings/branches/edit.vue": 2379,
	"./settings/campaigns/add": 8644,
	"./settings/campaigns/add.vue": 8644,
	"./settings/campaigns/edit": 5130,
	"./settings/campaigns/edit.vue": 5130,
	"./settings/categories/add": 5577,
	"./settings/categories/add.vue": 5577,
	"./settings/categories/edit": 2051,
	"./settings/categories/edit.vue": 2051,
	"./settings/configurations/edit": 1091,
	"./settings/configurations/edit.vue": 1091,
	"./settings/machines/add": 837,
	"./settings/machines/add.vue": 837,
	"./settings/machines/edit": 7114,
	"./settings/machines/edit.vue": 7114,
	"./settings/points/edit": 665,
	"./settings/points/edit.vue": 665,
	"./settings/products/add": 7685,
	"./settings/products/add-stock": 6517,
	"./settings/products/add-stock.vue": 6517,
	"./settings/products/add.vue": 7685,
	"./settings/products/edit": 4412,
	"./settings/products/edit.vue": 4412,
	"./settings/products/stock-history": 2043,
	"./settings/products/stock-history.vue": 2043,
	"./settings/staff/add": 6317,
	"./settings/staff/add.vue": 6317,
	"./settings/staff/edit": 5350,
	"./settings/staff/edit.vue": 5350,
	"./settings/symptoms/add": 9470,
	"./settings/symptoms/add.vue": 9470,
	"./settings/symptoms/edit": 2589,
	"./settings/symptoms/edit.vue": 2589,
	"./settings/treatments/add": 1182,
	"./settings/treatments/add.vue": 1182,
	"./settings/treatments/edit": 3873,
	"./settings/treatments/edit.vue": 3873,
	"./settings/warehouses/add": 6544,
	"./settings/warehouses/add.vue": 6544,
	"./settings/warehouses/edit": 5756,
	"./settings/warehouses/edit.vue": 5756,
	"./supportTickets/add": 8891,
	"./supportTickets/add.vue": 8891,
	"./supportTickets/callback": 1144,
	"./supportTickets/callback.vue": 1144,
	"./supportTickets/complaint": 8195,
	"./supportTickets/complaint.vue": 8195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5471;